import type { AttributeValue, Attributes } from '@opentelemetry/api';
export type { Span, SpanOptions } from '@opentelemetry/api';
export { SpanStatusCode } from '@opentelemetry/api';

export type SpanAttribute = AttributeValue;
export type SpanAttributes = Attributes;

export enum SpanNames {
  TRACK_ANALYTICS_AMPLITUDE = 'track_analytics_amplitude',
  TRACK_ANALYTICS_EVERFLOW_ATTRIBUTION_PARAMETERS = 'track_analytics_everflow_attribution_parameters',
  REVALIDATE_STATIC_PATH = 'revalidate_static_path',
}
